(() => {
  const DATA_ID = 'UpsellPopupData';
  const STORAGE_PREFIX = 'upsellPopupShown:';
  let isUpsellAdd = false;

  function getData() {
    const el = document.getElementById(DATA_ID);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function getOverlay() {
    return document.getElementById('UpsellPopupOverlay');
  }

  function getLabels() {
    const overlay = getOverlay();
    return {
      decline: overlay?.dataset.declineLabel || 'Nein danke',
      close: overlay?.dataset.closeLabel || 'Schließen',
      more: overlay?.dataset.moreLabel || 'Mehr anzeigen',
      add: overlay?.dataset.addLabel || 'In den Warenkorb',
      adding: overlay?.dataset.addingLabel || 'Wird hinzugefügt…',
      added: overlay?.dataset.addedLabel || 'Hinzugefügt ✓',
      soldOut: overlay?.dataset.soldoutLabel || 'Ausverkauft'
    };
  }

  function getShown(popupId){
    const n = parseInt(sessionStorage.getItem(STORAGE_PREFIX + popupId) || '0', 10);
    return Number.isFinite(n) ? n : 0;
  }

  function incShown(popupId){
    sessionStorage.setItem(STORAGE_PREFIX + popupId, String(getShown(popupId) + 1));
  }

  function closePopup() {
    const overlay = getOverlay();
    if (!overlay) return;
    overlay.setAttribute('hidden', 'hidden');
  }

  async function refreshCartCountOnly() {
    // Avoid breaking the header cart icon: update only the number via /cart.js
    try {
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      const count = Number(cart.item_count || 0);

      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!bubble) return;

      const spans = bubble.querySelectorAll('span');
      spans.forEach(s => { s.textContent = String(count); });

      if (count <= 0) {
        bubble.classList.add('hidden');
        bubble.setAttribute('hidden', 'hidden');
      } else {
        bubble.classList.remove('hidden');
        bubble.removeAttribute('hidden');
      }
    } catch (_) {}
  }

  async function addVariantToCart(variantId) {
    isUpsellAdd = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Add failed');

      // Update cart count without touching header HTML
      await refreshCartCountOnly();
      return true;
    } finally {
      setTimeout(() => { isUpsellAdd = false; }, 250);
    }
  }

  // Simple formatter (keeps it light). If you want perfect money_format later, we can upgrade.
  function formatMoney(cents){
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function openPopup(data) {
    const overlay = getOverlay();
    if (!overlay) return;

    const labels = getLabels();

    // Ensure popup visible
    overlay.removeAttribute('hidden');

    // Header
    overlay.querySelector('.upsell-title').textContent = data.title || '';
    const desc = overlay.querySelector('.upsell-desc');
    desc.textContent = data.description || '';
    desc.style.display = data.description ? '' : 'none';

    // Footer button reset (Nein danke)
    const footerBtn = overlay.querySelector('.upsell-decline-btn');
    if (footerBtn) footerBtn.textContent = labels.decline;

    // More button reset
    const moreWrap = overlay.querySelector('.upsell-more');
    const moreBtn = overlay.querySelector('.upsell-more-btn');
    if (moreBtn) moreBtn.textContent = labels.more;
    if (moreWrap) moreWrap.setAttribute('hidden', 'hidden');
    if (moreBtn) moreBtn.onclick = null;

    // Render items
    const container = overlay.querySelector('.upsell-items');
    container.innerHTML = '';

    (data.recommendations || []).forEach((p) => {
      const variants = p.variants || [];
const firstAvailable = variants.find(v => v.available) || null;
const firstAny = variants[0] || null;
const hasMultiple = !p.hasOnlyDefaultVariant && variants.length > 1;

// Wenn keine verfügbare Variante existiert -> selectedId = null -> Button disabled
let selectedId = firstAvailable ? firstAvailable.id : null;

const div = document.createElement('div');
div.className = 'upsell-item';

div.innerHTML = `
  <div class="upsell-media">
    ${p.image ? `<img class="upsell-img" src="${p.image}" alt="">` : ``}
  </div>

  <div class="upsell-content">
    <a class="upsell-item-title" href="${p.url}">${p.title}</a>
    <div class="upsell-price">${
      firstAvailable ? formatMoney(firstAvailable.price)
      : (firstAny ? formatMoney(firstAny.price) : '')
    }</div>

    ${hasMultiple ? `<select class="upsell-variants" aria-label="Variante auswählen"></select>` : ''}
  </div>

  <div class="upsell-actions-inline">
    <button class="button button--primary upsell-add-btn" type="button">${labels.add}</button>
  </div>
`;

// Button immer direkt holen (für alle Fälle!)
const btn = div.querySelector('.upsell-add-btn');

// Initialer Button-State: komplett ausverkauft => disabled + soldout label
if (!selectedId) {
  btn.disabled = true;
  btn.classList.add('is-disabled');
  btn.textContent = labels.soldOut;
} else {
  btn.disabled = false;
  btn.textContent = labels.add;
}

// Variant dropdown
if (hasMultiple) {
  const select = div.querySelector('.upsell-variants');

  variants.forEach(v => {
    const opt = document.createElement('option');
    opt.value = String(v.id);
    opt.textContent = v.available ? v.title : `${v.title} (${labels.soldOut})`;
    opt.disabled = !v.available;

    // default selection: first available
    if (selectedId === v.id) opt.selected = true;
    select.appendChild(opt);
  });

  select.addEventListener('change', () => {
    selectedId = parseInt(select.value, 10);
    const v = variants.find(x => x.id === selectedId);

    // Preis updaten
    if (v) div.querySelector('.upsell-price').textContent = formatMoney(v.price);

    // Button updaten
    if (v && v.available) {
      btn.disabled = false;
      btn.classList.remove('is-disabled');
      btn.textContent = labels.add;
    } else {
      btn.disabled = true;
      btn.classList.add('is-disabled');
      btn.textContent = labels.soldOut;
    }
  });
}

btn.addEventListener('click', async () => {
  if (!selectedId) return;

  btn.classList.add('is-loading');
  btn.textContent = labels.adding;
  btn.disabled = true;

  try {
    await addVariantToCart(selectedId);

    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    btn.textContent = labels.added;

    // Footer -> "Schließen"
    if (footerBtn) footerBtn.textContent = labels.close;
  } catch (_) {
    btn.classList.remove('is-loading');
    btn.disabled = false;
    btn.textContent = labels.add;
  }
});

container.appendChild(div);

    });

    // ===== Layout logic: columns + modal width based on count =====
    const items = Array.from(container.querySelectorAll('.upsell-item'));
    const count = items.length;

    // Columns: IMPORTANT -> prevent "shrunk card" when only 1 item
    // Desktop: 1->1 col, 2->2 cols, 3+->3 cols
    const desktopCols = count <= 1 ? 1 : (count === 2 ? 2 : 3);
    overlay.style.setProperty('--upsell-cols', String(desktopCols));
    overlay.style.setProperty('--upsell-cols-tablet', String(Math.min(2, Math.max(1, desktopCols))));
    overlay.style.setProperty('--upsell-cols-mobile', '1');

    // Modal width: 1 narrow, 2 medium, 3+ max
    if (count <= 1) {
      overlay.style.setProperty('--upsell-modal-max', '520px');
    } else if (count === 2) {
      overlay.style.setProperty('--upsell-modal-max', '820px');
    } else {
      overlay.style.setProperty('--upsell-modal-max', '1000px');
    }

    // ===== "Mehr anzeigen": Desktop limit 3, Mobile limit 1 =====
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const limit = isMobile ? 1 : 3;

    // Hide "Mehr anzeigen" default
    if (moreWrap) moreWrap.setAttribute('hidden', 'hidden');

    if (items.length > limit) {
      items.forEach((el, idx) => {
        if (idx >= limit) el.classList.add('is-hidden');
      });

      if (moreWrap && moreBtn) {
        moreWrap.removeAttribute('hidden');
        moreBtn.onclick = () => {
          items.forEach(el => el.classList.remove('is-hidden'));
          moreWrap.setAttribute('hidden', 'hidden');
        };
      }
    } else {
  items.forEach(el => el.classList.remove('is-hidden'));
  if (moreWrap) moreWrap.setAttribute('hidden', 'hidden');
    }

  }

function maybeShowPopup() {
  const data = getData();
  if (!data) return;

  const overlay = getOverlay();
  const currentMarket = overlay?.dataset.currentMarket;

  const allowedMarkets = data.markets || [];

  // Wenn kein Market ausgewählt wurde → Popup nicht anzeigen
  if (!allowedMarkets.length) return;

  // Wenn aktueller Market nicht erlaubt → nicht anzeigen
  if (!allowedMarkets.includes(currentMarket)) return;

  const max = parseInt(data.maxShows, 10);
  const maxShows = Number.isFinite(max) ? max : 1;
  if (maxShows <= 0) return;

  if (getShown(data.popupId) >= maxShows) return;

  incShown(data.popupId);
  openPopup(data);
}


  // Close handlers
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t && t.hasAttribute('data-upsell-close')) closePopup();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePopup();
  });

  // Hook fetch: show popup after successful add-to-cart on product page
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const res = await originalFetch(input, init);

    try {
      const url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';
      const isCartAdd = url.includes('/cart/add');
      if (isCartAdd && res.ok && !isUpsellAdd) {
        if (document.getElementById(DATA_ID)) {
          setTimeout(maybeShowPopup, 120);
        }
      }
    } catch (_) {}

    return res;
  };
})();
